import { axios, post, fetch, patch, put, postJson } from '../../http'
export default {
  login(params) {
    return post('/Login/UserAPI/Login', params)
  },
  updatePass(params) {
    return post('/Login/UserAPI/updatePass', params)
  },
}
